module.exports = __webpack_public_path__ + "media/images/fm_3-ce431ad39a472f6e522efd5ca2162b70.png";